export function planAmount(value) {
  const amount = Number(String(value ?? '').replace(/[^\d.-]/g, ''));
  return Number.isFinite(amount) && amount >= 0 ? amount : 0;
}

export function planOffer(plan, catalog, introEligible) {
  const regular = planAmount(plan.price);
  const intro = planAmount(plan.price_desc);
  const hasIntro = introEligible && plan.tag === 'month' && intro > 0 && intro < regular;
  const monthly = catalog.find(item => item.tag === 'month' && item.group_id === plan.group_id && planAmount(item.price) > 0);
  const annualReference = plan.tag === 'year' && monthly ? Math.round(planAmount(monthly.price) * 1200) / 100 : 0;
  const annualSavings = annualReference > regular ? Math.round((annualReference - regular) * 100) / 100 : 0;
  return {
    regular,
    display: hasIntro ? intro : plan.tag === 'year' ? regular / 12 : regular,
    hasIntro,
    introPercent: hasIntro ? Math.floor((regular - intro) / regular * 100) : 0,
    annualReference,
    annualSavings,
    annualPercent: annualSavings > 0 ? Math.floor(annualSavings / annualReference * 100) : 0,
  };
}

export function isCurrentFastSpringMember(config) {
  return config?.subscription_provider === 'fastspring' && config.has_subscription === true && config.legacy_subscription_present === true;
}

export function isSubscribedPlan(config, productId) {
  return !!productId && config?.has_subscription === true && config.has_paid_access === true && config.current_product_id === productId;
}
